import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
// import { navigationBlocks } from './navigation-blocks.js'
import { accordion } from './accordion.js'
import { iconCarousel } from './icon-carousel.js'
import { introductionVideo } from './introduction-video.js'
import { stackedBlocks } from './stacked-blocks.js'
import { archiveFeatured } from './archive-featured.js'
// import { spline } from './spline.js'
import { threejs } from './threejs.js'
// import { footer } from './footer.js'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const animation = () => {
	headings()
	// paragraph()
	enter()
	// navigationBlocks()
	accordion()
	iconCarousel()
	introductionVideo()
	stackedBlocks()
	archiveFeatured()
	// spline()
	threejs()
	// footer()
}

const headings = () => {

	let els = document.querySelectorAll('[data-animation="heading"]')

	if (!els.length) return

	document.fonts.ready.then(() => {
		els.forEach(el => {

			el.style.opacity = 1

			let trigger = el,
				split = new SplitText(el, { type: 'lines, words', linesClass: 'line', wordsClass: 'word' }),
				delay = el.getAttribute('data-delay') ? el.getAttribute('data-delay') : 0

			if (el.dataset.trigger == 'parent') {
				trigger = el.parentElement
			} else if (el.dataset.trigger == 'grandparent') {
				trigger = el.parentElement.parentElement
			} else if (el.dataset.trigger == 'body') {
				trigger = document.body
			}

			gsap.fromTo(split.words, {
				y: '122%',
				opacity: 1,
				rotate: "4deg",
			}, {
				y: 0,
				opacity: 1,
				rotate: "0deg",
				stagger: { each: 0.03, amount: 0.3 },
				duration: 0.8,
				delay: delay,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: trigger,
					start: 'top 85%',
					// markers: true,
				}
			})
		})
	})
}

const paragraph = () => {

	let sections = document.querySelectorAll('[data-animation="paragraph"]')

	if (!sections.length) return

	document.fonts.ready.then(() => {
		sections.forEach(section => {

			let els = section.querySelectorAll('h2, h3, h4, p, li, .line')

			els.forEach(el => {

				let trigger = section,
					split = new SplitText(el, { type: 'lines', linesClass: 'line' }),
					delay = section.getAttribute('data-delay') ? section.getAttribute('data-delay') : 0

				if (section.dataset.trigger == 'parent') {
					trigger = section.parentElement
				} else if (section.dataset.trigger == 'grandparent') {
					trigger = section.parentElement.parentElement
				} else if (section.dataset.trigger == 'body') {
					trigger = document.body
				}

				setTimeout(() => {

					section.style.opacity = 1

					split.lines.forEach(el => {
						const text = el.innerHTML
						const wrap = document.createElement('div')
						wrap.classList.add('line-inner')
						wrap.innerHTML = text
						el.innerHTML = ''
						el.appendChild(wrap)
					})

					let lines = section.querySelectorAll('.line-inner')

					if (!lines.length) return

					gsap.fromTo(lines, {
						y: '108%',
					}, {
						y: 0,
						stagger: 0.1,
						duration: 0.8,
						delay: delay,
						ease: 'power2.out',
						scrollTrigger: {
							trigger: trigger,
							start: 'top 85%',
							// markers: true,
						}
					})

				}, delay);
			})
		})
	})
}

const enter = () => {

	let els = document.querySelectorAll('[data-animation="enter"], [data-animation="fade-in"], [data-animation="image"]')

	if (!els.length) return

	els.forEach(el => {

		let trigger = el,
			delay = el.dataset.delay ? el.dataset.delay : 0

		if (el.dataset.trigger == 'parent') {
			trigger = el.parentElement
		} else if (el.dataset.trigger == 'grandparent') {
			trigger = el.parentElement.parentElement
		} else if (el.dataset.trigger == 'body') {
			trigger = document.body
		}

		ScrollTrigger.create({
			trigger: trigger,
			start: "top 85%",
			onEnter: () => {
				setTimeout(() => {
					el.setAttribute('data-animation-status', 'active')
				}, delay * 1000)
			},
			// markers: true,
		})
	})
}

export default () => { }